import classes from "./Footer.module.css";

function Footer() {
  return (
    <>
      <footer>
        <section className={classes.sobre}>
          <div className="interface">
            <div className={`flex ${classes.flex}`}>
              <div className={classes.imgSobre}>
                <img src="img/globe.gif" alt="Globe" />
              </div>
              <div className={classes.txtSobre}>
                <p>
                  Somos especialistas em transformar dados em conhecimento estratégico para o seu negócio. Utilizamos tecnologia e análise avançada para gerar percepções de valor acerca de dados, apoiar decisões e otimizar operações.
                  <br /><br />Saiba mais também através de nossos perfis nas redes sociais.
                </p>
                <div className="btnSocial">
                  <a href="/"><button><i className="bi bi-instagram"></i></button></a>
                  <a href="/"><button><i className="bi bi-youtube"></i></button></a>
                  <a href="/"><button><i className="bi bi-linkedin"></i></button></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="interface">
          <div className={classes.lineFooter}>
            <div className={`flex ${classes.flex}`}></div>
          </div>
          <div className={`${classes.lineFooter} ${classes.borda}`}>
            <p>© 2026 TERRADATA - Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
